<template>
  <div class="sub-box">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-form-item prop="categoryId" label="类目">
          <el-col :span="24">
            <el-cascader
              ref="refSubCat"
              style="width: 100%"
              v-model="form.categoryId"
              :options="categoryList"
              :props="{
                value: 'id',
                label: 'name',
                chihildren: 'children',
                checkStrictly: true,
              }"
              @change="handleSubCat"
            ></el-cascader>
          </el-col>
        </el-form-item>
        <el-col :span="24">
          <el-form-item prop="title" label="标题">
            <el-input v-model="form.title" placeholder="请输入标题"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="content" label="正文">
            <quill-editor ref="text" v-model="form.content" />
            <!-- <my-editor :content.sync="form.content"></my-editor> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="display: flex; justify-content: center">
        <el-button class="search-btn btn-gray" @click="getColse()"
          >取消</el-button
        >
        <el-button class="search-btn btn-blue" @click="getCategoryAdd"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import editBreadCrumb from "../../views/layout/components/editBreadCrumb.vue";
import { listToTree } from "@/class/utils";
export default {
  components: { editBreadCrumb },
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      form: {
        categoryId: [],
        oneCategoryId: undefined,
        twoCategoryId: undefined,
        threeCategoryId: undefined,
        oneCategoryName: undefined,
        twoCategoryName: undefined,
        threeCategoryName: undefined,
        title: undefined,
        content: undefined,
      },
      categoryParentList: [],
      categoryList: [],
      // editorOption: {
      //   modules: {
      //     toolbar: {
      //       container: [
      //         ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
      //       ],
      //     },
      //   },
      // },
      rules: {
        categoryId: [
          { required: true, message: "请输入类目", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入正文", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCategory();
    if (this.params.id) {
      this.getInfo();
    }
  },
  methods: {
    getColse() {
      this.$emit("update:visible", false);
    },
    // 添加类目
    getCategoryAdd() {
      let data = {
        ...this.form,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http.post("information/save", data).then((res) => {
            const { data: resData } = res;
            if (resData.code == 200) {
              this.$emit("onchange");
              this.$emit("update:visible", false);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubCat(val) {
      console.log(val, "val");
      this.form.oneCategoryName =
        this.$refs["refSubCat"].getCheckedNodes()[0]?.pathLabels[0] || "";
      this.form.twoCategoryName =
        this.$refs["refSubCat"].getCheckedNodes()[0]?.pathLabels[1] || "";
      this.form.threeCategoryName =
        this.$refs["refSubCat"].getCheckedNodes()[0]?.pathLabels[2] || "";
      //   this.form.categoryName = name.join("-");

      this.form.oneCategoryId = this.form?.categoryId[0] || "";
      this.form.twoCategoryId = this.form?.categoryId[1] || "";
      this.form.threeCategoryId = this.form?.categoryId[2] || "";
    },
    getInfo() {
      this.$http
        .get(`/information/detail?id=${this?.params.id}`)
        .then((res) => {
          const { data: resData } = res;
          if (resData.code == 200) {
            this.form = resData.data;
            console.log(this.form.categoryId, "this.form.categoryId");
            let categoryId = [
              resData.data?.oneCategoryId,
              resData.data?.twoCategoryId,
              resData.data?.threeCategoryId,
            ];
            this.form.categoryId = categoryId.filter((item) => {
              if (item) {
                return item;
              }
            });
          }
        });
    },
    // 分类
    getCategory() {
      this.$http.get("informationCategory/list").then((res) => {
        const { data: resData } = res;
        if (resData.code == 200) {
          this.categoryList = listToTree(resData.data.list, "id", "parentId");
        }
      });
    },
  },
};
</script>
<style scoped></style>
